import { createContext, useContext, type ReactNode } from 'react';

export interface SportsSearchContextValue {
  openSearch: () => void;
}

const SportsSearchContext = createContext<SportsSearchContextValue | null>(null);

export function SportsSearchProvider({
  openSearch,
  children,
}: {
  openSearch: () => void;
  children: ReactNode;
}) {
  return (
    <SportsSearchContext.Provider value={{ openSearch }}>
      {children}
    </SportsSearchContext.Provider>
  );
}

/** Opens the sports search overlay when rendered under AppShell. */
export function useSportsSearch(): SportsSearchContextValue | null {
  return useContext(SportsSearchContext);
}
